var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTurnRightBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.773,
    height: 10.711,
    viewBox: "0 0 10.773 10.711",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "turn-right-black",
    transform: "translate(-519.52 -97.977)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1881",
    "data-name": "Groupe 1881",
    transform: "translate(520.27 99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2816",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2818",
    d: "M6.193,6.741C2.651,6.282,0,4.662,0,2.735,0,1.687.81.729,2.087,0",
    transform: "translate(0)",
    fill: "none",
    stroke: "#212547",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "path2822",
    d: "M0,0V4.135L3.08,2.068Z",
    transform: "translate(6.193 4.802)",
    fill: "#212547",
    stroke: "#212547",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurnRightBlack);
export default __webpack_public_path__ + "static/media/turn-right-black.292995f3bde53b8021a6be0c3f184587.svg";
export { ForwardRef as ReactComponent };